<template>
  <nav class="navbar navbar-expand-sm navbar-light bg-white shadow-sm">
    <div class="container">
      <div class="col-sm-3 pt-1">
          <a class="navbar-brand" :href="mimedUrl">
            <img src="/img/logomimed.svg" class="d-block mx-auto logoCustom" alt="">
          </a>
       </div>
        <ul class="navbar-nav">
          <li class="nav-item dropdown profile-menu">
            <a class="nav-link dropdown-toggle"
               href="#"
               id="navbarDropdown"
               role="button"
               data-toggle="dropdown"
               aria-haspopup="true"
               aria-expanded="false">
              <img
                src=""
                alt=""
                class="avatar-img d-block">
            </a>
            <div class="dropdown-menu dropdown-menu-right border-0" aria-labelledby="navbarDropdown">
              <a href="#" class="dropdown-item text-secondary">Perfil</a>
              <a class="dropdown-item text-secondary" href="#">Ayuda</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-secondary" href="#"  onclick="event.preventDefault();document.getElementById('logout-form').submit();">Cerrar sesión</a>
              <form id="logout-form" action="" method="POST" style="display: none;" >
            </form>
            </div>
          </li>
        </ul>
        <div class="d-flex align-items-right pointer-click" @click="exit">
          <div>
            <img src="/img/user-solid.png" class="d-block mx-auto w-48" alt="">
          </div>
          <div class="mt-2 p-2">
            Cerrar sesión
          </div>
        </div>
    </div>
    <Modal/>
  </nav>

</template>

<script>
import Modal from "./../../components/modals/modals"

export default {
    name: "navbar",
    components: { Modal },
    data: () => ({
      mimedUrl: process.env.MIX_MIMED_FRONT_URL
    }),
    methods: {
      exit(){
        this.$root.$emit('bv::show::modal', 'my-modal-exit')
      }
    },
}
</script>

<style lang="scss" scoped>
  .pointer-click{
    cursor: pointer;
  }
.navbar {
  height: auto !important;
  padding: 1rem 0;
}

.logo_nav {
    width: 10rem;
}

.dropdown-menu.menu-apps {
    min-width: 14rem;
}

.nav-item {
    margin-left: 0.5rem;
    margin-right: 0.5rem;

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }
}

.nav-item .nav-link {
    height: 2.5rem;
}

.dropdown-toggle {
    display: flex;
    align-items: center;
    justify-content: center;

    &:after {
        display: none;
    }
}

.btn-login {
    display: flex;
    align-items: center;
}

.icon-apps {
    width: 3rem;
    margin-bottom: 0.5rem;
}

.avatar-img {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
}

.container-fluid {
    width: 85%;
}

.w-48{
  width: 48px;
}

.logoCustom{
  width: 130px;
}

@media screen and (min-width: 992px) {
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 1rem;
        padding-left: 1rem;
    }
}

@media (min-width: 576px) {
    .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: 1rem;
        padding-left: 1rem;
    }
}

@media screen and (max-width: 575px) {
    .logo_nav {
        width: 7.5rem;
    }
    .navbar-nav {
        flex-direction: row;
    }
    .nav-item {
        margin-left: 1rem;
        margin-right: 1rem;
    }
    .dropdown-menu {
        position: absolute;
        left: -8rem;
        top: 3rem;
    }
    .btn-login {
        width: 2.5rem;
        height: 2.5rem;
        justify-content: center;
        border-radius: 50%;
    }
}
</style>
